<template>
	<div class="dropdown"
		:class="{ show: show, open: show }"
		v-on:click="toggle" v-on-clickaway="close">
		<button class="btn btn-link dropdown-toggle"
			:class="{ 'no-padding': !padding, 'no-background': !background }"
			type="button"
			v-on:click="toggleButton"
			id="dropdownMenuButton"
			data-toggle="dropdown"
			aria-haspopup="true"
			aria-expanded="false">
			<slot name="button"></slot>
		</button>
		<div class="dropdown-menu animation-scale-up animation-duration-250"
			:class="{
				'dropdown-menu-right': right,
				'dropup': dropup,
				'dropup-right': dropupRight
			}"
			aria-labelledby="dropdownMenuButton">
			<slot></slot>
			<div class="dropdown-divider" v-if="$slots.sorting"/>
			<slot name="sorting"></slot>
		</div>
	</div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway';

export default {
	name: 'DropdownButton',
	props: {
		right: {
			default: true,
			type: Boolean,
		},
		background: {
			default: false,
			type: Boolean,
		},
		padding: {
			default: false,
			type: Boolean,
		},
		isEnableClickAway: {
			default: true,
			type: Boolean,
		},
		dropup: {
			default: false,
			type: Boolean,
		},
		dropupRight: {
			default: false,
			type: Boolean,
		},
	},
	directives: { onClickaway },
	data() {
		return {
			show: false,
		};
	},
	methods: {
		toggle() {
			if (this.isEnableClickAway) {
				this.show = !this.show;
			}
		},
		toggleButton() {
			if (!this.isEnableClickAway) {
				this.show = !this.show;
			}
		},
		close() {
			if (this.isEnableClickAway) {
				this.show = false;
			}
		},
	},
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/themes/variables.scss';

.dropdown.show.open {
	.dropup {
		transform: translate3d(-50px, -200px, 0px);
	}
	.dropup-right {
		transform: translate3d(180px, -60px, 0px);
	}
}


.dropdown-menu {
	z-index: 10000;
	font-size: 0.85rem;
	.dropdown-divider {
		border-color: darken($gray-600, 5%);
	}
}

.dropdown-toggle {
	// color: $body-color;
	text-decoration: none;
}

.dropdown-toggle::after {
	display: none;
}

.no-padding {
	padding: 0;
}

.no-background {
	background: none;
}

a {
	cursor: pointer;
}

.dropdown-item {
	// color: #76838f;
	color: $body-color;
	background: none;
	cursor: pointer;

	&:hover {
		background-color: $gray-200;
	}
}

.dropdown-item[disabled] {
	border-color: #adb5bd;
	color: #495057;
	pointer-events: none;
	cursor: default;
}

a.disabled {
	pointer-events: none;
	cursor: default;
	//color: #ddd;
}

.show {
	.dropdown-menu {
		position: inline-block;
		transform: translate3d(0px, 38px, 0px);
		top: 0px;
		left: 0px;
		will-change: transform;
		display: block;
	}

	.dropdown-menu-right {
		left: auto;
		right: 0;
	}

	.dropdown-item.active, .dropdown-item:active {
		background: none;
		cursor: pointer;
	}
}


.no-padding {
	.dropdown-menu {
		top: -10px;
	}
}

</style>



// WEBPACK FOOTER //
// src/components/elements/DropdownButton.vue